import { useState } from 'react'
import {
  EDITOR_TOP_BAR_HEIGHT,
  EDITOR_LEFT_BAR_WIDTH,
} from '../../cnst/editor.cnst'
import { useEditorActions, useEditorUi } from '../../utils/hooks'
import ContentTypeTab from '../ContentTypeTab'
import SettingsTab from '../SettingsTab'
import Sitemap from '../Sitemap'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import { useTr } from '../../utils/useTr'
import { LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

enum Tab {
  CONTENT = 'CONTENT',
  SETTINGS = 'SETTINGS',
  SITEMAP = 'SITEMAP',
}

const tabs: Record<Tab, { name: TrKey; icon: LucideIconName }> = {
  [Tab.CONTENT]: {
    name: TrKey.editorTabContent,
    icon: LucideIconName.CirclePlus,
  },
  [Tab.SETTINGS]: {
    name: TrKey.editorTabSettings,
    icon: LucideIconName.Settings,
  },
  [Tab.SITEMAP]: {
    name: TrKey.editorTabSitemap,
    icon: LucideIconName.Files,
  },
}

const toggleMenuButtonClasses = 'font-semibold text-primary-400'

const EditorBarLeft = () => {
  const { tr } = useTr()
  const { toggleLeftBar } = useEditorActions()
  const { leftBarOpen, fullScreen } = useEditorUi()
  const [activeTab, setActiveTab] = useState(Tab.CONTENT)

  if (!leftBarOpen)
    return (
      <div
        className={`fixed bottom-0 left-0 z-20 border-r px-4 py-2 border-t rounded-tr bg-white border-slate-500 ${
          fullScreen ? 'hidden' : ''
        }`}
      >
        <button className={toggleMenuButtonClasses} onClick={toggleLeftBar}>
          {tr(TrKey.editorShowMenu)}
        </button>
      </div>
    )

  return (
    <div
      className='fixed z-20 border-r bg-white border-slate-500 transition-all'
      style={{
        top: EDITOR_TOP_BAR_HEIGHT,
        left: fullScreen ? '-100%' : 0,
        bottom: 0,
        width: EDITOR_LEFT_BAR_WIDTH,
      }}
    >
      <div className='bg-slate-200'>
        {Object.entries(tabs).map(([key, tab]) => (
          <button
            key={key}
            onClick={() => setActiveTab(key as Tab)}
            className={`py-2 px-4 text-black ${activeTab === key ? 'bg-white' : 'bg-slate-200'}`}
          >
            <Icon name={tab.icon} className='size-5' />
          </button>
        ))}
      </div>

      <div className='font-semibold text-primary-400 border-b p-2 border-slate-500'>
        <p>{tr(tabs[activeTab].name)}</p>
      </div>

      <div className='px-2 pt-2 pb-48 overflow-y-scroll max-h-full'>
        {activeTab === Tab.CONTENT && <ContentTypeTab />}
        {activeTab === Tab.SETTINGS && <SettingsTab />}
        {activeTab === Tab.SITEMAP && <Sitemap />}
      </div>

      <div className='flex gap-2 absolute bottom-0 left-0 px-2 py-4 bg-white border-t border-slate-500 w-full'>
        <button className={toggleMenuButtonClasses} onClick={toggleLeftBar}>
          {tr(TrKey.editorHideMenu)}
        </button>
      </div>
    </div>
  )
}

export default EditorBarLeft
